import api from "./client";

export async function getWorkOrderApprovals(orderNo) {
  const res = await api.get("/reports/work-order-approvals", {
    params: { order_no: orderNo },
  });
  return res.data.data; // { header, operations }
}

export async function getProductionStatus(params = {}) {
  const stage = params?.stage ? String(params.stage) : null;
  const search = params?.search ? String(params.search) : null;

  const res = await api.get("/reports/production-status", {
    params: {
      ...(stage ? { stage } : {}),
      ...(search ? { search } : {}),
    },
  });

  return res.data.data.items;
}

